var _circle, _circle2, _path, _path2, _path3, _circle3, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoosterPumpStationOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.4402,
    cy: 21.0926,
    r: 4.94021,
    stroke: "#637381"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.4401,
    cy: 21.0913,
    r: 4.56978,
    fill: "#2486FD",
    fillOpacity: 0.2,
    stroke: "#1070CA",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3696 12.6953H16.8805V21.0649L15.9389 18.6237L14.3696 16.8801V12.6953Z",
    fill: "#637381"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 9.34782L18.1619 11.8587H13.0881L15.625 9.34782Z",
    fill: "#CBDFF7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 6L18.1619 8.51087H13.0881L15.625 6Z",
    fill: "#CBDFF7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 8,
    r: 8,
    fill: "#FF4842"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7_151",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 3,
    width: 10,
    height: 10
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 3,
    width: 10,
    height: 10,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7_151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9375 12.125L21.3125 8.47917C21.0972 8.52778 20.8906 8.59375 20.6927 8.67708C20.4948 8.76042 20.309 8.86111 20.1354 8.97917C19.9896 9.07639 19.8281 9.12674 19.6511 9.13021C19.474 9.13368 19.3264 9.07292 19.2084 8.94792C19.0834 8.82292 19.0261 8.67188 19.0365 8.49479C19.0469 8.31771 19.1215 8.17708 19.2604 8.07292C19.4202 7.95486 19.5886 7.84722 19.7656 7.75C19.9427 7.65278 20.125 7.5625 20.3125 7.47917L19.375 6.54167C19.1945 6.63889 19.0191 6.74132 18.849 6.84896C18.6788 6.9566 18.5139 7.07292 18.3542 7.19792C18.2153 7.30903 18.0573 7.36458 17.8802 7.36458C17.7031 7.36458 17.5556 7.30208 17.4375 7.17708C17.3125 7.05208 17.2535 6.90278 17.2604 6.72917C17.2674 6.55556 17.3403 6.41319 17.4792 6.30208C17.632 6.17708 17.7882 6.05729 17.9479 5.94271C18.1077 5.82813 18.2778 5.72222 18.4584 5.625L17.875 5.04167C17.7986 4.96528 17.7604 4.86806 17.7604 4.75C17.7604 4.63194 17.7986 4.53472 17.875 4.45833C17.9514 4.38194 18.0486 4.34375 18.1667 4.34375C18.2847 4.34375 18.382 4.38194 18.4584 4.45833L25.5313 11.5313C25.6146 11.6146 25.6563 11.7135 25.6563 11.8281C25.6563 11.9427 25.6146 12.0417 25.5313 12.125C25.4479 12.2014 25.349 12.2413 25.2344 12.2448C25.1198 12.2483 25.0209 12.2083 24.9375 12.125ZM22 11.75C21.7084 11.75 21.4618 11.6476 21.2604 11.4427C21.059 11.2378 20.9584 10.9931 20.9584 10.7083C20.9584 10.4167 21.059 10.1701 21.2604 9.96875C21.4618 9.76736 21.7084 9.66667 22 9.66667C22.2917 9.66667 22.5382 9.76736 22.7396 9.96875C22.941 10.1701 23.0417 10.4167 23.0417 10.7083C23.0417 10.9931 22.941 11.2378 22.7396 11.4427C22.5382 11.6476 22.2917 11.75 22 11.75ZM24.8438 8.88542C24.7327 8.99653 24.6024 9.05035 24.4531 9.04688C24.3038 9.0434 24.1736 8.98611 24.0625 8.875L22.8542 7.66667C22.7639 7.57639 22.7465 7.48264 22.8021 7.38542C22.8577 7.28819 22.9549 7.25694 23.0938 7.29167C23.4063 7.36806 23.7031 7.47569 23.9844 7.61458C24.2656 7.75347 24.5278 7.91667 24.7709 8.10417C24.8959 8.20139 24.967 8.32813 24.9844 8.48438C25.0018 8.64063 24.9549 8.77431 24.8438 8.88542ZM26.5625 7.17708C26.4445 7.30208 26.2986 7.36632 26.125 7.36979C25.9514 7.37326 25.7952 7.31944 25.6563 7.20833C25.1563 6.79861 24.5955 6.4809 23.974 6.25521C23.3524 6.02951 22.6945 5.91667 22 5.91667C21.8542 5.91667 21.7136 5.92188 21.5781 5.93229C21.4427 5.94271 21.3056 5.95833 21.1667 5.97917C20.9931 6.00694 20.8368 5.97049 20.6979 5.86979C20.559 5.7691 20.4757 5.63194 20.4479 5.45833C20.4202 5.28472 20.4584 5.12847 20.5625 4.98958C20.6667 4.85069 20.8056 4.76736 20.9792 4.73958C21.1459 4.71181 21.3143 4.69271 21.4844 4.68229C21.6545 4.67188 21.8264 4.66667 22 4.66667C22.8681 4.66667 23.6858 4.81076 24.4531 5.09896C25.2205 5.38715 25.9097 5.78472 26.5209 6.29167C26.6597 6.40972 26.7327 6.55556 26.7396 6.72917C26.7465 6.90278 26.6875 7.05208 26.5625 7.17708Z",
    fill: "#FCFCFC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoosterPumpStationOffline);
export default __webpack_public_path__ + "static/media/boosterPumpStationOffline.01f3d93594c62951786465e2dbe30e42.svg";
export { ForwardRef as ReactComponent };